import {
  loginSchema,
  addCategorySchema,
  addAdminSchema,
  editCategorySchema,
  createAdvSchema,
  addNotificationSchema,
} from './schemas'

const VALIDATIONS = {
  loginSchema,
  addCategorySchema,
  addAdminSchema,
  editCategorySchema,
  createAdvSchema,
  addNotificationSchema,
}

export default VALIDATIONS
